<div class="page-bg font-sans pb-12">
  <div class="max-w-5xl mx-auto px-5 sm:px-7 lg:px-10 py-6">

    <!-- Header -->
<div class="interests-header mb-8">

  <!-- Back button + Title in one line -->
  <div class="interests-header-row">

    <button
      type="button"
      class="back-btn"
      (click)="goBack()"
      aria-label="Go back">

      <span class="material-symbols-outlined">
        arrow_back
      </span>

    </button>

    <h1 class="font-display font-extrabold text-2xl text-primary m-0">
      Interests
    </h1>

  </div>

  <!-- Description -->
  <p class="text-secondary text-sm mt-1 m-0 interests-description">
    Manage all your sent, received, and accepted interest requests.
  </p>

</div>

    <!-- Tabs -->
    <div class="flex gap-1 bg-white rounded-2xl p-1.5 border border-primary/10 shadow-sm mb-6 w-fit">
      <button
        (click)="setTab('received')"
        class="px-5 py-2 rounded-xl text-xs font-bold transition-all border-0 cursor-pointer"
        [ngClass]="activeTab === 'received'
          ? 'bg-primary text-white shadow-sm'
          : 'text-secondary bg-transparent hover:bg-primary/5'"
      >
        Received
        <span *ngIf="receivedInterests.length > 0" class="ml-1.5 bg-white/30 text-white px-1.5 py-0.5 rounded-full text-[10px]">{{ receivedInterests.length }}</span>
      </button>
      <button
        (click)="setTab('sent')"
        class="px-5 py-2 rounded-xl text-xs font-bold transition-all border-0 cursor-pointer"
        [ngClass]="activeTab === 'sent'
          ? 'bg-primary text-white shadow-sm'
          : 'text-secondary bg-transparent hover:bg-primary/5'"
      >
        Sent
        <span *ngIf="sentInterests.length > 0" class="ml-1.5 bg-secondary/20 text-secondary px-1.5 py-0.5 rounded-full text-[10px]">{{ sentInterests.length }}</span>
      </button>
      <button
        (click)="setTab('accepted')"
        class="px-5 py-2 rounded-xl text-xs font-bold transition-all border-0 cursor-pointer"
        [ngClass]="activeTab === 'accepted'
          ? 'bg-primary text-white shadow-sm'
          : 'text-secondary bg-transparent hover:bg-primary/5'"
      >
        Accepted
        <span *ngIf="totalAccepted > 0" class="ml-1.5 bg-emerald-100 text-emerald-700 px-1.5 py-0.5 rounded-full text-[10px]">{{ totalAccepted }}</span>
      </button>
      <button
        (click)="setTab('rejected')"
        class="px-5 py-2 rounded-xl text-xs font-bold transition-all border-0 cursor-pointer"
        [ngClass]="activeTab === 'rejected'
          ? 'bg-primary text-white shadow-sm'
          : 'text-secondary bg-transparent hover:bg-primary/5'"
      >
        Rejected
        <span *ngIf="totalRejected > 0" class="ml-1.5 bg-rose-100 text-rose-700 px-1.5 py-0.5 rounded-full text-[10px]">{{ totalRejected }}</span>
      </button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="flex items-center justify-center py-20">
      <div class="h-8 w-8 border-4 border-primary/20 border-t-primary rounded-full animate-spin"></div>
    </div>

    <!-- ===== RECEIVED TAB ===== -->
    <div *ngIf="!loading && activeTab === 'received'">
      <div *ngIf="receivedInterests.length === 0" class="bg-white rounded-3xl p-12 text-center border border-primary/5 shadow-sm">
        <div class="h-16 w-16 bg-rose-50 rounded-full flex items-center justify-center mx-auto mb-4">
          <span class="material-symbols-outlined text-3xl text-rose-400">favorite</span>
        </div>
        <h3 class="font-display font-bold text-primary text-base m-0">No Pending Interests</h3>
        <p class="text-secondary text-xs mt-2 m-0">When someone sends you an interest, it will appear here.</p>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        <div *ngFor="let interest of receivedInterests" class="pcard">

          <!-- Image -->
          <div class="pcard-img">
            <img *ngIf="base64Images[interest._profileId]"
              [src]="'data:image/jpeg;base64,' + base64Images[interest._profileId]" />
            <div *ngIf="!base64Images[interest._profileId]" class="pcard-avatar-placeholder">
              <span class="material-symbols-outlined text-[72px]" style="color: rgba(176,30,62,0.15);">person</span>
            </div>
            <div class="pcard-gradient"></div>
            <!-- New badge -->
            <span class="pcard-match-badge">New Request</span>
            <!-- Overlay -->
            <div class="pcard-overlay">
              <h3 class="font-display text-[15px] font-bold m-0 text-white truncate">{{ interest._name }}</h3>
              <div class="text-white/80 text-[11px] mt-0.5">{{ interest._age }} yrs · {{ interest._location }}</div>
            </div>
          </div>

          <!-- Actions -->
          <div class="pcard-actions flex-col gap-2 pt-3 pb-3 px-3" style="flex-direction: column; gap: 7px;">
            <div class="flex gap-2">
              <button (click)="acceptInterest(interest)"
                class="btn-connect btn-ripple flex-1" style="flex: 1;">
                <span class="material-symbols-outlined text-[14px]">check</span> Accept
              </button>
              <button (click)="rejectInterest(interest)"
                class="btn-view flex-1" style="flex: 1; color: #B01E3E;">
                <span class="material-symbols-outlined text-[14px]">close</span> Decline
              </button>
            </div>
            <button (click)="viewProfile(interest._profileId)" class="btn-view w-full">
              <span class="material-symbols-outlined text-[14px]">visibility</span> View Profile
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- ===== SENT TAB ===== -->
    <div *ngIf="!loading && activeTab === 'sent'">
      <div *ngIf="sentInterests.length === 0" class="bg-white rounded-3xl p-12 text-center border border-primary/5 shadow-sm">
        <div class="h-16 w-16 bg-primary/5 rounded-full flex items-center justify-center mx-auto mb-4">
          <span class="material-symbols-outlined text-3xl text-primary/40">send</span>
        </div>
        <h3 class="font-display font-bold text-primary text-base m-0">No Sent Interests</h3>
        <p class="text-secondary text-xs mt-2 m-0">Interests you've sent that are still pending will appear here.</p>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        <div *ngFor="let interest of sentInterests" class="pcard">

          <div class="pcard-img">
            <img *ngIf="base64Images[interest._profileId]"
              [src]="'data:image/jpeg;base64,' + base64Images[interest._profileId]" />
            <div *ngIf="!base64Images[interest._profileId]" class="pcard-avatar-placeholder">
              <span class="material-symbols-outlined text-[72px]" style="color: rgba(176,30,62,0.15);">person</span>
            </div>
            <div class="pcard-gradient"></div>
            <span class="pcard-match-badge">Pending</span>
            <div class="pcard-overlay">
              <h3 class="font-display text-[15px] font-bold m-0 text-white truncate">{{ interest._name }}</h3>
              <div class="text-white/80 text-[11px] mt-0.5">{{ interest._age }} yrs · {{ interest._location }}</div>
            </div>
          </div>

          <div class="pcard-actions flex-col" style="flex-direction: column; gap: 7px; padding: 10px;">
            <button (click)="cancelSentInterest(interest)"
              title="Click to revert request"
              class="btn-pending group relative cursor-pointer hover:bg-red-50 hover:border-red-200 transition-all w-full" style="flex: unset; width: 100%;">
              <span class="flex items-center justify-center gap-1 group-hover:hidden">
                <span class="material-symbols-outlined text-[14px]">hourglass_top</span> Awaiting Response
              </span>
              <span class="hidden group-hover:inline-flex items-center justify-center gap-1 text-red-600 font-bold">
                <span class="material-symbols-outlined text-[14px]">close</span> Cancel Request
              </span>
            </button>
            <button (click)="viewProfile(interest._profileId)" class="btn-view w-full" style="flex: unset; width: 100%;">
              <span class="material-symbols-outlined text-[14px]">visibility</span> View Profile
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== ACCEPTED TAB ===== -->
    <div *ngIf="!loading && activeTab === 'accepted'">
      
      <!-- Subtabs for Accepted Category -->
      <div class="flex gap-6 mb-6 border-b border-primary/10 px-2">
         <button (click)="acceptedSubTab = 'byMe'" 
                 class="pb-3 border-b-[3px] transition-colors bg-transparent border-t-0 border-l-0 border-r-0 cursor-pointer font-bold text-sm"
                 [ngClass]="acceptedSubTab === 'byMe' ? 'border-primary text-primary' : 'border-transparent text-secondary hover:text-primary'">
            Accepted By Me <span class="ml-1.5 bg-surface-container-highest text-secondary text-[10px] px-1.5 py-0.5 rounded-full">{{ acceptedByMeInterests.length }}</span>
         </button>
         <button (click)="acceptedSubTab = 'me'" 
                 class="pb-3 border-b-[3px] transition-colors bg-transparent border-t-0 border-l-0 border-r-0 cursor-pointer font-bold text-sm"
                 [ngClass]="acceptedSubTab === 'me' ? 'border-primary text-primary' : 'border-transparent text-secondary hover:text-primary'">
            Accepted Me <span class="ml-1.5 bg-surface-container-highest text-secondary text-[10px] px-1.5 py-0.5 rounded-full">{{ acceptedMeInterests.length }}</span>
         </button>
      </div>

      <!-- ACCEPTED BY ME CONTENT -->
      <div *ngIf="acceptedSubTab === 'byMe'">
        <div *ngIf="acceptedByMeInterests.length === 0" class="bg-white rounded-3xl p-12 text-center border border-primary/5 shadow-sm">
          <div class="h-16 w-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <span class="material-symbols-outlined text-3xl text-blue-400">handshake</span>
          </div>
          <h3 class="font-display font-bold text-primary text-base m-0">No Accepted Requests</h3>
          <p class="text-secondary text-xs mt-2 m-0">When you accept someone's interest request, they will appear here.</p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          <div *ngFor="let interest of acceptedByMeInterests" class="pcard">
            <div class="pcard-img">
              <img *ngIf="base64Images[interest._profileId]"
                [src]="'data:image/jpeg;base64,' + base64Images[interest._profileId]" />
              <div *ngIf="!base64Images[interest._profileId]" class="pcard-avatar-placeholder">
                <span class="material-symbols-outlined text-[72px]" style="color: rgba(176,30,62,0.15);">person</span>
              </div>
              <div class="pcard-gradient"></div>
              <span class="pcard-match-badge" style="background: #054730; color: white;">Accepted By You</span>
              <div class="pcard-overlay">
                <h3 class="font-display text-[15px] font-bold m-0 text-white truncate flex items-center gap-1">
                  {{ interest._name }}
                  <span *ngIf="interest._isVerified" class="material-symbols-outlined text-xs text-emerald-400">verified</span>
                </h3>
                <div class="text-white/80 text-[11px] mt-0.5">{{ interest._age }} yrs · {{ interest._location }}</div>
              </div>
            </div>

            <div class="pcard-actions flex-col" style="flex-direction: column; gap: 7px; padding: 10px;">
              <div class="flex gap-2 w-full">
                <a routerLink="/chat" class="btn-connect btn-ripple flex-1 flex items-center justify-center gap-1.5 no-underline text-xs" style="flex: 1; background: #10b981;">
                  <span class="material-symbols-outlined text-[14px]">chat</span> Chat
                </a>
                <button (click)="viewProfile(interest._profileId)" class="btn-view flex-1 flex items-center justify-center gap-1 text-xs" style="flex: 1;">
                  <span class="material-symbols-outlined text-[14px]">visibility</span> View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ACCEPTED ME CONTENT -->
      <div *ngIf="acceptedSubTab === 'me'">
        <div *ngIf="acceptedMeInterests.length === 0" class="bg-white rounded-3xl p-12 text-center border border-primary/5 shadow-sm">
          <div class="h-16 w-16 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <span class="material-symbols-outlined text-3xl text-emerald-400">handshake</span>
          </div>
          <h3 class="font-display font-bold text-primary text-base m-0">No Accepted Outgoing Requests</h3>
          <p class="text-secondary text-xs mt-2 m-0">When someone accepts your sent interest request, they will appear here.</p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          <div *ngFor="let interest of acceptedMeInterests" class="pcard">
            <div class="pcard-img">
              <img *ngIf="base64Images[interest._profileId]"
                [src]="'data:image/jpeg;base64,' + base64Images[interest._profileId]" />
              <div *ngIf="!base64Images[interest._profileId]" class="pcard-avatar-placeholder">
                <span class="material-symbols-outlined text-[72px]" style="color: rgba(176,30,62,0.15);">person</span>
              </div>
              <div class="pcard-gradient"></div>
              <span class="pcard-match-badge" style="background: #10b981; color: white;">Connected</span>
              <div class="pcard-overlay">
                <h3 class="font-display text-[15px] font-bold m-0 text-white truncate flex items-center gap-1">
                  {{ interest._name }}
                  <span *ngIf="interest._isVerified" class="material-symbols-outlined text-xs text-emerald-400">verified</span>
                </h3>
                <div class="text-white/80 text-[11px] mt-0.5">{{ interest._age }} yrs · {{ interest._location }}</div>
              </div>
            </div>

            <div class="pcard-actions flex-col" style="flex-direction: column; gap: 7px; padding: 10px;">
              <div class="flex gap-2 w-full">
                <a routerLink="/chat" class="btn-connect btn-ripple flex-1 flex items-center justify-center gap-1.5 no-underline text-xs" style="flex: 1; background: #10b981;">
                  <span class="material-symbols-outlined text-[14px]">chat</span> Chat
                </a>
                <button (click)="viewProfile(interest._profileId)" class="btn-view flex-1 flex items-center justify-center gap-1 text-xs" style="flex: 1;">
                  <span class="material-symbols-outlined text-[14px]">visibility</span> View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== REJECTED TAB ===== -->
    <div *ngIf="!loading && activeTab === 'rejected'">
      
      <!-- Subtabs for Rejected Category -->
      <div class="flex gap-6 mb-6 border-b border-primary/10 px-2">
         <button (click)="rejectedSubTab = 'byMe'" 
                 class="pb-3 border-b-[3px] transition-colors bg-transparent border-t-0 border-l-0 border-r-0 cursor-pointer font-bold text-sm"
                 [ngClass]="rejectedSubTab === 'byMe' ? 'border-primary text-primary' : 'border-transparent text-secondary hover:text-primary'">
            I Rejected <span class="ml-1.5 bg-surface-container-highest text-secondary text-[10px] px-1.5 py-0.5 rounded-full">{{ rejectedByMeInterests.length }}</span>
         </button>
         <button (click)="rejectedSubTab = 'me'" 
                 class="pb-3 border-b-[3px] transition-colors bg-transparent border-t-0 border-l-0 border-r-0 cursor-pointer font-bold text-sm"
                 [ngClass]="rejectedSubTab === 'me' ? 'border-primary text-primary' : 'border-transparent text-secondary hover:text-primary'">
            Rejected Me <span class="ml-1.5 bg-surface-container-highest text-secondary text-[10px] px-1.5 py-0.5 rounded-full">{{ rejectedMeInterests.length }}</span>
         </button>
      </div>

      <!-- I REJECTED CONTENT -->
      <div *ngIf="rejectedSubTab === 'byMe'">
        <div *ngIf="rejectedByMeInterests.length === 0" class="bg-white rounded-3xl p-12 text-center border border-primary/5 shadow-sm">
          <div class="h-16 w-16 bg-rose-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <span class="material-symbols-outlined text-3xl text-rose-400">block</span>
          </div>
          <h3 class="font-display font-bold text-primary text-base m-0">No Rejected Requests</h3>
          <p class="text-secondary text-xs mt-2 m-0">When you decline someone's interest request, they will appear here.</p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          <div *ngFor="let interest of rejectedByMeInterests" class="pcard opacity-80">
            <div class="pcard-img grayscale">
              <img *ngIf="base64Images[interest._profileId]"
                [src]="'data:image/jpeg;base64,' + base64Images[interest._profileId]" />
              <div *ngIf="!base64Images[interest._profileId]" class="pcard-avatar-placeholder">
                <span class="material-symbols-outlined text-[72px]" style="color: rgba(176,30,62,0.15);">person</span>
              </div>
              <div class="pcard-gradient"></div>
              <span class="pcard-match-badge" style="background: #f43f5e; color: white;">You Declined</span>
              <div class="pcard-overlay">
                <h3 class="font-display text-[15px] font-bold m-0 text-white truncate line-through decoration-rose-300">{{ interest._name }}</h3>
                <div class="text-white/80 text-[11px] mt-0.5">{{ interest._age }} yrs · {{ interest._location }}</div>
              </div>
            </div>

            <div class="pcard-actions" style="padding: 10px;">
              <button (click)="viewProfile(interest._profileId)" class="btn-view w-full" style="flex: unset; width: 100%;">
                <span class="material-symbols-outlined text-[14px]">visibility</span> View Profile
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- REJECTED ME CONTENT -->
      <div *ngIf="rejectedSubTab === 'me'">
        <div *ngIf="rejectedMeInterests.length === 0" class="bg-white rounded-3xl p-12 text-center border border-primary/5 shadow-sm">
          <div class="h-16 w-16 bg-rose-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <span class="material-symbols-outlined text-3xl text-rose-400">block</span>
          </div>
          <h3 class="font-display font-bold text-primary text-base m-0">No Declined Requests</h3>
          <p class="text-secondary text-xs mt-2 m-0">When someone declines your sent interest request, they will appear here.</p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          <div *ngFor="let interest of rejectedMeInterests" class="pcard opacity-80">
            <div class="pcard-img grayscale">
              <img *ngIf="base64Images[interest._profileId]"
                [src]="'data:image/jpeg;base64,' + base64Images[interest._profileId]" />
              <div *ngIf="!base64Images[interest._profileId]" class="pcard-avatar-placeholder">
                <span class="material-symbols-outlined text-[72px]" style="color: rgba(176,30,62,0.15);">person</span>
              </div>
              <div class="pcard-gradient"></div>
              <span class="pcard-match-badge" style="background: #64748b; color: white;">They Declined</span>
              <div class="pcard-overlay">
                <h3 class="font-display text-[15px] font-bold m-0 text-white truncate line-through decoration-rose-300">{{ interest._name }}</h3>
                <div class="text-white/80 text-[11px] mt-0.5">{{ interest._age }} yrs · {{ interest._location }}</div>
              </div>
            </div>

            <div class="pcard-actions" style="padding: 10px;">
              <button (click)="viewProfile(interest._profileId)" class="btn-view w-full" style="flex: unset; width: 100%;">
                <span class="material-symbols-outlined text-[14px]">visibility</span> View Profile
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
